/**
 * Created by andrey on 08.08.2025
 */

cc.RotateBy = function (duration, deltaAngleX, deltaAngleY) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._angleX = 0;
    this._startAngleX = 0;
    this._angleY = 0;
    this._startAngleY = 0;

    if (deltaAngleX !== undefined) {
        this.initWithDuration(duration, deltaAngleX, deltaAngleY);
    }
};

cc.RotateBy.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.RotateBy,

    initWithDuration: function (duration, deltaAngleX, deltaAngleY) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._angleX = deltaAngleX || 0;
            this._angleY = deltaAngleY || this._angleX;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._startAngleX = target.rotationX;
        this._startAngleY = target.rotationY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            this.target.rotationX = this._startAngleX + this._angleX * dt;
            this.target.rotationY = this._startAngleY + this._angleY * dt;
        }
    }
});

cc.rotateBy = (duration, deltaAngleX, deltaAngleY) => new cc.RotateBy(duration, deltaAngleX, deltaAngleY);
